<script setup lang="ts">
const modelValue = defineModel<boolean>()
defineProps({
  label: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div class="flex items-center mt-2 gap-4">
    <div class="label">
      <span class="label-text font-semibold">
        {{ label }}
      </span>
    </div>
    <div class="flex items-center">
      <input type="checkbox" v-model="modelValue" class="toggle toggle-xs" />
    </div>
  </div>
</template>
